/**
 * en-GB messages added by Phase 1 task W4 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w4EnGB = {
    // Today board
    'today.greeting': "Hi {name}, here's the latest at",
    'today.noSite': 'You have no sites yet. Add a site to see who is on site.',
    'today.live': 'Live',
    'today.reconnecting': 'Reconnecting',
    'today.truncated': 'There are more people than can be shown. Choose a group or use the search to narrow the list.',
    'today.tiles': 'People in now',
    'today.tabs': 'Groups',
    'today.tab.everyone': 'Everyone',
    'today.tab.label': '{name} ({count})',
    'today.search': 'Search by name, host or details',
    'today.show': 'Which people to show',
    'today.show.in': 'In now',
    'today.show.all': 'Everyone today',
    'today.layout': 'Layout',
    'today.layout.list': 'List',
    'today.layout.cards': 'Cards',
    'today.caption': 'People on site',
    'today.status.in': 'In',
    'today.status.out': 'Signed out',
    'today.col.name': 'Name',
    'today.col.group': 'Group',
    'today.col.host': 'Host',
    'today.col.details': 'Details',
    'today.col.in': 'Signed in',
    'today.col.out': 'Signed out',
    'today.col.actions': 'Actions',
    'today.card.host': 'Host: {name}',
    'today.card.times': '{from} to {to}',
    // How a person signed in
    'today.method.kiosk': 'Kiosk',
    'today.method.portal': 'Portal',
    'today.method.companion': 'Companion app',
    'today.method.contactless': 'Contactless',
    'today.method.point': 'Sign-in point',
    'today.method.auto': 'Automatic',
    'today.method.api': 'Integration',
    'today.method.system': 'System',
    'today.flag.offline': 'Offline',
    'today.flag.clock_adjusted': 'Time corrected',
    // Sign in from the portal
    'today.signIn.button': 'Sign someone in',
    'today.signIn.title': 'Sign someone in',
    'today.signIn.submit': 'Sign in',
    'today.signIn.done': 'Signed in.',
    'today.signIn.group': 'Group',
    'today.signIn.member': 'Person',
    'today.signIn.memberSearch': 'Start typing a name',
    'today.signIn.memberResults': 'People found',
    'today.signIn.visitorName': 'Visitor name',
    'today.signIn.whoRequired': 'Say who is signing in.',
    'today.signIn.host': 'Host (optional)',
    'today.signIn.hostHint': 'Type at least two letters of their name.',
    'today.signIn.hostResults': 'Hosts found',
    'today.signIn.hostChosen': 'Host: {name}',
    'today.signIn.change': 'Change',
    'today.signIn.choose': 'Choose',
    'today.signIn.answerRequired': 'This question needs an answer.',
    // Sign out
    'today.signOut.button': 'Sign out',
    'today.signOut.for': 'Sign out {name}',
    'today.signOut.title': 'Sign out {name}',
    'today.signOut.submit': 'Sign out',
    'today.signOut.done': 'Signed out.',
    'today.signOut.time': 'Time signed out',
    'today.signOut.timeHint': 'Leave empty to sign out now, or pick an earlier time.',
    'today.signOutAll.button': 'Sign out all',
    'today.signOutAll.title': 'Sign out everyone',
    'today.signOutAll.text': 'Everyone still signed in will be signed out now. This cannot be undone.',
    'today.signOutAll.group': 'Who to sign out',
    'today.signOutAll.everyone': 'Everyone at this site',
    'today.signOutAll.submit': 'Sign out all',
    'today.signOutAll.done': 'Signed out {count} people.',
    // Visit drawer
    'today.drawer.title': 'Visit',
    'today.drawer.signedIn': 'Signed in',
    'today.drawer.signedOut': 'Signed out',
    'today.drawer.stillIn': 'Still on site',
    'today.drawer.protected': 'Protected',
    'today.drawer.answers': 'Answers',
    'today.drawer.noAnswers': 'No questions were asked.',
    'today.drawer.redacted': 'Hidden (sensitive)',
    'today.drawer.notices': 'Notices accepted',
    'today.drawer.noNotices': 'No notices were accepted.',
    'today.drawer.noticeLine': '{title} (version {version}), accepted {when}',
    'today.drawer.history': 'History',
    'today.drawer.editTimes': 'Edit times',
    'today.drawer.saveTimes': 'Save times',
    'today.drawer.notes': 'Notes',
    'today.drawer.noNotes': 'No notes.',
    'today.drawer.saveNotes': 'Save notes',
    'today.drawer.printBadge': 'Print badge',
    'today.drawer.protect': 'Protect from deletion',
    'today.drawer.unprotect': 'Remove protection',
    'today.drawer.delete': 'Delete visit',
    'today.drawer.deleted': 'Visit deleted.',
    'today.event.sign_in': 'Signed in',
    'today.event.sign_out': 'Signed out',
    'today.event.edit': 'Edited',
    'today.event.notApplied': 'Not applied',
};
//# sourceMappingURL=w4.js.map